__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "axs-shop-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.37.0", () => (__webpack_require__.e(1610).then(() => (() => (__webpack_require__(41610))))));
			register("@azure/msal-react", "1.5.7", () => (Promise.all([__webpack_require__.e(2540), __webpack_require__.e(8283), __webpack_require__.e(2143)]).then(() => (() => (__webpack_require__(30159))))));
			register("@emotion/react", "11.13.3", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(8283), __webpack_require__.e(3177)]).then(() => (() => (__webpack_require__(3177))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(8283), __webpack_require__.e(4999)]).then(() => (() => (__webpack_require__(24999))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(8283), __webpack_require__.e(1437)]).then(() => (() => (__webpack_require__(41437))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(8283), __webpack_require__.e(5339)]).then(() => (() => (__webpack_require__(25339))))));
			register("@emotion/styled", "11.13.0", () => (Promise.all([__webpack_require__.e(5912), __webpack_require__.e(8283), __webpack_require__.e(7482), __webpack_require__.e(9677)]).then(() => (() => (__webpack_require__(72784))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(8283), __webpack_require__.e(92), __webpack_require__.e(2276)]).then(() => (() => (__webpack_require__(2276))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(8283), __webpack_require__.e(6632), __webpack_require__.e(5237)]).then(() => (() => (__webpack_require__(25237))))));
			register("@splitsoftware/splitio-redux", "1.7.1", () => (Promise.all([__webpack_require__.e(7418), __webpack_require__.e(8283), __webpack_require__.e(6653)]).then(() => (() => (__webpack_require__(17418))))));
			register("notistack", "2.0.8", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(6878), __webpack_require__.e(8553), __webpack_require__.e(8283), __webpack_require__.e(9205), __webpack_require__.e(7482), __webpack_require__.e(2779)]).then(() => (() => (__webpack_require__(98553))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(9998), __webpack_require__.e(8283)]).then(() => (() => (__webpack_require__(99998))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(7647), __webpack_require__.e(8283), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(47647))))));
			register("react-router-dom", "6.28.0", () => (Promise.all([__webpack_require__.e(7868), __webpack_require__.e(8283), __webpack_require__.e(9205)]).then(() => (() => (__webpack_require__(37868))))));
			register("react", "18.3.1", () => (__webpack_require__.e(2483).then(() => (() => (__webpack_require__(82483))))));
			initExternal(22977);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};